<template>
  <div id="userProfilePageWrapper">
    <div v-if="centerPanel !== 'invoiceDetails'" id="userProfileDefault" class="page">
      <div class="hp-row content-default flex">

        <div class="left column">
          <div class="user-profile-col-content">
            <!-- Delete User Notification Card -->
            <div v-if="deletedUserNotification" class="gradient-card card green-check-content">
              <div class="green-check-icon"></div>
            </div>

            <!-- Profile Menu Card -->
            <div v-if="!deletedUserNotification" :class="['gradient-card card profile-menu-card', {'plain-card': $utils.isPageForLicenses()}]">
              <div class="header">
                <div :class="profileColumnHeaderIconClass"></div>
                <h4 class="title">{{$t('label.settings')}}</h4>
              </div>

              <div class="body profile-menu">
                <el-button v-if="visibleProfileMenu.includes(profileMenu.account)"
                  :class="['cstm-btn-white menu-item', {'selected': (centerPanel === profileMenu.account)}]"
                  @click="handleProfileMenuItemClick(profileMenu.account)">{{$t('label.accountInfo')}}
                </el-button>

                <el-button v-if="visibleProfileMenu.includes(profileMenu.customerInfo)"
                  :class="['cstm-btn-white menu-item', {'selected': (centerPanel === profileMenu.customerInfo)}]"
                  @click="handleProfileMenuItemClick(profileMenu.customerInfo)">{{$t('label.customerInfo')}}
                </el-button>

                <el-button v-if="visibleProfileMenu.includes(profileMenu.billingDetails)"
                  :class="['cstm-btn-white menu-item', {'selected': (centerPanel === profileMenu.billingDetails)}]"
                  @click="handleProfileMenuItemClick(profileMenu.billingDetails)">{{$t('label.billingDetails')}}
                </el-button>

                <el-button v-if="visibleProfileMenu.includes(profileMenu.userManagement)"
                  :class="['cstm-btn-white menu-item', {'selected': (centerPanel === profileMenu.userManagement)}]"
                  @click="handleProfileMenuItemClick(profileMenu.userManagement)">{{$t('label.userManagement')}}
                </el-button>

                <el-button v-if="visibleProfileMenu.includes(profileMenu.invoices)"
                  :class="['cstm-btn-white menu-item', {'selected': (centerPanel === profileMenu.invoices)}]"
                  @click="handleProfileMenuItemClick(profileMenu.invoices)">{{$t('label.invoice', 2)}}
                </el-button>

                <el-button v-if="visibleProfileMenu.includes(profileMenu.api)"
                  :class="['cstm-btn-white menu-item api', {'selected': (centerPanel === profileMenu.api)}]"
                  @click="handleProfileMenuItemClick(profileMenu.api)">{{'API'}}
                </el-button>
              </div>

              <div @click="handleProfileMenuItemClick(profileMenu.leaveAccount)" class="cstm-btn-white menu-item width-auto leave-account">{{$t('label.leaveAccount')}}</div>
            </div>
          </div>
        </div>

        <div v-if="centerPanel !== null || deletedUserNotification" class="center column animated fadeInRight w-full">
          <!-- Delete User Notification Content -->
          <div v-if="deletedUserNotification" class="user-profile-col-content">
            <div class="delete-user-notification">
              <h1 class="delete-user-success-text">{{$t('label.accountIsDeleted')}}</h1>
              <p>{{$t('label.loggedOffInFewSeconds')}}</p>
            </div>
          </div>

          <!-- Selected Profile Menu Item Content -->
          <div v-if="!deletedUserNotification && userInfo" class="user-profile-col-content">
            <!-- Common Account Information -->
            <account-information v-if="centerPanel === profileMenu.account && !$utils.isPageForLicenses()"
              :userInfoProp="userInfo"
              :userDetailsProp="userDetails"
              :userAccountsProp="userAccounts"
              :accessorComponentProp="'userProfile'"
              @user-account-change="handleUserAddressSubCompChange($event)">
            </account-information>
            <!--Activate site Account Information -->
            <user-account v-if="centerPanel === profileMenu.account && $utils.isPageForLicenses()"
              :userInfoProp="userInfo"
              :userDetailsProp="userDetails"
              :accessorComponentProp="'userProfile'"
              @user-account-change="handleUserAddressSubCompChange($event)">
            </user-account>
            <!-- Customer Info -->
            <user-address v-else-if="centerPanel === profileMenu.customerInfo"
              :userInfoProp="userInfo" :accessorComponentProp="'userProfile'"
              @user-address-change="handleUserAddressSubCompChange($event)">
            </user-address>
            <!-- Billing Details -->
            <user-address v-else-if="centerPanel === profileMenu.billingDetails"
              :userInfoProp="userInfo" :accessorComponentProp="'userProfile'"
              @user-address-change="handleUserAddressSubCompChange($event)">
            </user-address>
            <!-- Invoice Details -->
            <user-invoice-list v-else-if="centerPanel === profileMenu.invoices"
              :userInfoProp="userInfo" :accessorComponentProp="'userProfile'">
            </user-invoice-list>
          </div>
        </div>
      </div>
    </div>

    <div v-if="centerPanel === 'invoiceDetails'" id="userProfileWhite" class="page white" ref="asideLayoutStructure">
      <user-invoice-details></user-invoice-details>
    </div>

    <!-- Dialog -->
    <edit-account-name-dialog v-if="activeDialog === dialog.editAccountName"
      :userInfoProp="userInfo"
      @edit-account-name-dialog-change="handleAccountInfoEvent($event)">
    </edit-account-name-dialog>
  </div>
</template>

<script src="./user-settings.js"></script>
<style lang="scss" src="./user-settings.scss"></style>
